"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoidLogger = exports.ConsoleLogger = void 0;
class ConsoleLogger {
    debug(message, ...args) {
        console.debug(`[DEBUG] ${message}`, ...args);
    }
    info(message, ...args) {
        console.info(`[INFO] ${message}`, ...args);
    }
    warn(message, ...args) {
        console.warn(`[WARN] ${message}`, ...args);
    }
    error(message, ...args) {
        console.error(`[ERROR] ${message}`, ...args);
    }
}
exports.ConsoleLogger = ConsoleLogger;
class VoidLogger {
    debug(_message, ..._args) { }
    info(_message, ..._args) { }
    warn(_message, ..._args) { }
    error(_message, ..._args) { }
}
exports.VoidLogger = VoidLogger;
